import get from 'lodash/get'
import map from 'lodash/map'

import { R, sumCurrency } from '../../../utils/currency'
import { ASSESSMENT_TYPE } from '../reducer'

export const buildAssessment = (formValues, assessmentId, assessmentType) => {
  return (
    {
      [ASSESSMENT_TYPE.LIFE_COVER]: () => buildLifeCover(formValues, assessmentId),
      [ASSESSMENT_TYPE.DISABILITY_COVER]: () => buildDisabilityCover(formValues, assessmentId),
      [ASSESSMENT_TYPE.INCOME_PROTECTION]: () => buildIncomeProtection(formValues, assessmentId)
    }[assessmentType]()
  )
}

const buildLifeCover = (formValues, lifeCoverAssessmentId) => ({
  id: lifeCoverAssessmentId,
  dependents: map(get(formValues, 'dependents', []), (dependent) => ({ ...dependent, value: R(get(dependent, 'value', 0)).value })),
  total_additional_assets: R(get(formValues, 'total_additional_assets', 0)).value,
  total_existing_life_cover: R(get(formValues, 'total_existing_life_cover', 0)).value,
  total_additional_liabilities: R(get(formValues, 'total_additional_liabilities', 0)).value,
  total_assets: sumCurrency([
    get(formValues, 'total_additional_assets', 0),
    get(formValues, 'total_from_selected_assets', 0)
  ]).value,
  total_provision: sumCurrency([
    get(formValues, 'total_additional_assets', 0),
    get(formValues, 'total_from_selected_assets', 0),
    get(formValues, 'total_existing_life_cover', 0),
    get(formValues, 'total_from_selected_risk_products', 0)
  ]).value,
  total_liabilities: sumCurrency([
    get(formValues, 'total_additional_liabilities', 0),
    get(formValues, 'total_from_selected_liabilities', 0)
  ]).value,
  total_from_selected_assets: R(get(formValues, 'total_from_selected_assets', 0)).value,
  total_from_selected_liabilities: R(get(formValues, 'total_from_selected_liabilities', 0)).value,
  include_estate_duty_in_required_cover: get(formValues, 'include_estate_duty_in_required_cover', true),
  assetables_attributes: get(formValues, 'assetables_attributes', []),
  liabilitiables_attributes: get(formValues, 'liabilitiables_attributes', []),
  risk_productables_attributes: get(formValues, 'risk_productables_attributes', []),
  total_from_selected_risk_products: R(get(formValues, 'total_from_selected_risk_products', 0)).value,
})

const buildDisabilityCover = (formValues, disabilityCoverAssessmentId) => ({
  id: disabilityCoverAssessmentId,
  existing_cover: R(get(formValues, 'existing_cover', 0)).value,
  lifestyle_adjustment_expenses: R(get(formValues, 'lifestyle_adjustment_expenses', 0)).value,
  total_immediate_expenses: sumCurrency([
    get(formValues, 'total_liabilities_expenses', 0),
    get(formValues, 'lifestyle_adjustment_expenses', 0)
  ]).value,
  total_liabilities_expenses: R(get(formValues, 'total_liabilities_expenses', 0)).value,
  total_from_selected_risk_products: R(get(formValues, 'total_from_selected_risk_products', 0)).value,
  risk_productables_attributes: get(formValues, 'risk_productables_attributes', []),
  liabilitiables_attributes: get(formValues, 'liabilitiables_attributes', []),
})

const buildIncomeProtection = (formValues, incomeProtectionAssessmentId) => ({
  id: incomeProtectionAssessmentId,
  existing_cover: R(get(formValues, 'existing_cover', 0)).value,
  monthly_budget_expenses: R(get(formValues, 'monthly_budget_expenses', 0)).value,
  total_monthly_expenses: sumCurrency([
    get(formValues, 'monthly_budget_expenses', 0),
    get(formValues, 'total_asset_monthly_contributions', 0)
  ]).value,
  total_asset_monthly_contributions: R(get(formValues, 'total_asset_monthly_contributions', 0)).value,
  total_from_selected_risk_products: R(get(formValues, 'total_from_selected_risk_products', 0)).value,
  risk_productables_attributes: get(formValues, 'risk_productables_attributes', []),
})
